import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { Box } from '@mui/material';
import { AutoLockFormsLevelType } from 'app/services/autoLockForms/autoLockForms.constants';
import PropTypes from 'prop-types';

import { selectIsAreaHidden, selectIsAreaLocked } from 'store/loanApplications/selectors';

import { disabledWrapperStyles } from './AutoLockSubsection.styles';

const AutoLockSubsection = ({ areaName, levelType, children }) => {
  const isHidden = useSelector(selectIsAreaHidden(areaName, levelType));
  const isLocked = useSelector(selectIsAreaLocked(areaName, levelType));

  if (isHidden) {
    return null;
  }

  if (isLocked) {
    return (
      <Box aria-disabled sx={disabledWrapperStyles}>
        {children}
      </Box>
    );
  }

  return children;
};

AutoLockSubsection.propTypes = {
  areaName: PropTypes.string.isRequired,
  levelType: PropTypes.oneOf(Object.values(AutoLockFormsLevelType)).isRequired,
  children: PropTypes.node,
};

export default memo(AutoLockSubsection);
